__turbopack_context__.v({
  "active": "_5P313q_active",
  "item": "_5P313q_item",
  "label": "_5P313q_label",
  "wrapper": "_5P313q_wrapper",
});
